import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { CompoundRecordComposerDetail } from "./components/CompoundRecordComposerDetail";
import { CompoundRecordComposersUpload } from "./components/CompoundRecordComposersUpload";
import { CompoundRecordComposersContainer } from "./components/compoundRecordComposers.container";

function ComposerDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.compoundRecordComposers.detail);
  const navigate = useNavigate();
  return (
    <Suspense fallback={<PageLoading />}>
      <CompoundRecordComposerDetail id={id} onBack={() => navigate("..")} />
    </Suspense>
  );
}

export function CompoundRecordComposersRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<CompoundRecordComposersContainer />} />
        <Route path="upload" element={<CompoundRecordComposersUpload />} />
        <Route path=":id" element={<ComposerDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
